@import '~style-sheet-helpers/core.less';
@import '../../../../../../../constants/spacing.module.less';

.table-container {
  background-color: var(--white);
  margin-top: @space-8;
}

.header-row {
  background-color: var(--grey-100);
  border-bottom: 1px solid var(--grey-400);
}

.verified-row {
  background-color: var(--green-100);
}

.verifying-row {
  background-color: var(--green-200);
}
